import { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client instance
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // 5 minutes
            staleTime: 5 * 60 * 1000,
            // 10 minutes
            gcTime: 10 * 60 * 1000,
            retry: (failureCount, error: any) => {
                // Don't retry on 4xx errors (client errors)
                if (
                    error?.response?.status >= 400 &&
                    error?.response?.status < 500
                ) {
                    return false;
                }
                // Retry up to 3 times for other errors
                return failureCount < 3;
            },
        },
    },
});

export const ReactQueryProvider = ({ children }: PropsWithChildren) => {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
};

export { queryClient };
